export var ADDON_ID = 'storybook/measure-addon';
export var TOOL_ID = "".concat(ADDON_ID, "/tool");
export var PARAM_KEY = 'measureEnabled';
export var EVENTS = {
  RESULT: "".concat(ADDON_ID, "/result"),
  REQUEST: "".concat(ADDON_ID, "/request"),
  CLEAR: "".concat(ADDON_ID, "/clear")
};